// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.folder-container {
  text-align: center;
  margin-left: 1rem;
  margin-right: 1rem;
  margin-bottom: 1.5rem;
  width: 100px;
  padding: 0;
  align-self: start;
  background: none;
  border: none;
  outline-color: transparent !important;
  cursor: pointer;
}
.folder-icon {
  font-size: 5em;
  line-height: 1.25em;
}
.folder-icon-color {
  color: #b3deee;
  font-size: 7rem;
  text-shadow: 1px 1px 0px #98c7d9;
  /*color: #ffc107;*/
}
.folder-name {
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
}

.flex-column .folder-container {
  display: flex;
  width: auto;
  min-width: 100px;
  text-align: left;
  margin: 0;
  margin-bottom: 1rem;
}
.flex-column .folder-icon,
.flex-column .folder-name {
  display: inline-flex;
}
.flex-column .folder-icon {
  font-size: 1.4em;
  margin-right: 1rem;
}
.file-icon-color {
  color: #999;
}

.kt-avatar .kt-avatar__upload:hover {
  transition: all 0.3s;
  background-color: #f44336;
  color: #fff;
}

.dorp-zone-media {
  border: 2px dashed #008fc780;
}

.media-files .kt-portlet .kt-portlet__body {
  padding-top: 0;
}

.kt-widget__files .kt-widget__media img.picture {
  width: 100%;
  height: 130px;
  object-fit: cover;
}

.kt-widget__files .kt-widget__media img.file {
  width: 7rem;
  height: 130px;
}
.kt-widget__media > img {
  height: 40vh;
}

.dragItem {
  position: absolute;
  top: 0;
  left: 0;
}

button.btn.not-allowed:hover {
  cursor: not-allowed !important;
}

.theme-scroll {
  height: 40vh !important;
}

.gallery .row > div {
  width: 160px;
}
.gallery .row > div > .media-folder {
  position: relative;
  padding-top: 10px;
}
.gallery .row > div > .media-folder::before {
  content: "";
  width: 50%;
  height: 10px;
  border-radius: 10px 10px 0px 0px;
  background-color: rgb(0, 119, 173);
  position: absolute;
  top: 0px;
  left: 0px;
}
.gallery .row > div > .media-folder a {
  width: 100%;
  height: 100px;
  background-color: #008fc7;
  border-radius: 0px 10px 10px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 10px;
}

.gallery .row > div > .media-folder .delete-item-button {
  position: absolute;
  top: 0;
  right: 0;
  width: 32px;
  height: 32px;
  background-color: #fd397a;
  transform: translate(4px, 0px) scale(0);
  border-radius: 5px;
  color: #fff;
  border: none;
  z-index: 1;
  opacity: 0;
  transition: transform ease 0.4s, opacity ease 0.4s;
}
.gallery .row > div > .media-folder:hover .delete-item-button {
  opacity: 1;
  transform: translate(4px, 0px) scale(1);
}

.gallery .row > div > .media-folder:hover .set-item-button {
  opacity: 1;
  transform: translate(5px, 0px) scale(1);
}

.gallery .row > div > .media-card {
  position: relative;
}

.gallery .row > div > .media-card::before {
  content: "";
  position: absolute;
  height: 110px;
  width: 100%;
  background-color: #cfdbe0;
  z-index: 0;
  transform: rotate(5deg);
  transform-origin: center;
  border-radius: 5px;
}

.gallery .row > div > .media-card .img-view {
  position: relative;
  z-index: 1;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 10px;
  height: 110px;
  overflow: hidden;
  border: solid 3px #fff;
  margin-bottom: 5px;
}
.gallery .row > div > .media-card .doc-view {
  position: relative;
  z-index: 1;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 10px;
  height: 110px;
  overflow: hidden;
  border: solid 3px #fff;
  margin-bottom: 5px;
  text-align: center;
}

.gallery .row > div > .media-card a > .img-src {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.media-card-dialog .img-src {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.gallery .row > div > .media-card a > .doc-src {
  height: 100%;
  object-fit: cover;
  object-position: center;
}

/* .gallery .row > div > .media-card .delete-item-button {
    position: absolute;
    top: 0;
    right: 0;
    width: 32px;
    height: 32px;
    background-color: #fd397a;
    transform: translate(4px, 0px) scale(0);
    border-radius: 5px;
    color: #fff;
    border: none;
    z-index: 1;
    opacity: 0;
    transition: transform ease 0.4s, opacity ease 0.4s;
  } */
.delete-item-button {
  cursor: pointer;
}
.set-item-button {
  cursor: pointer;
}
.item-name {
  cursor: pointer;
  color: rgb(0, 119, 173);
}
.gallery .row > div > .media-card:hover .delete-item-button {
  opacity: 1;
  transform: translate(4px, 0px) scale(1);
}
.folder-icon {
  color: #fff;
  padding: 14px;
  border-radius: 50%;
}

.table th,
.table td {
  border-top: 3px solid #ebedf2;
}
.customClass .tab-content {
  background-color: red;
}
.img-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.pop-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5%;
}
/* .img-container  > img {

  } */

.modal-lg {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}
.media-container {
  position: relative;
}
.media-container .delete-item-button {
  position: absolute;
  top: 0;
  z-index: 100;
  right: 0;
  width: 32px;
  height: 32px;
  background-color: #fd397a;
  transform: translate(4px, 0px) scale(0);
  border-radius: 5px;
  color: #fff;
  border: none;
  opacity: 0;
  transition: transform ease 0.4s, opacity ease 0.4s;
}
.media-container .set-item-button {
  position: absolute;
  top: 0;
  z-index: 100;
  left: 0;
  width: 32px;
  height: 32px;
  background-color: #fd397a;
  transform: translate(4px, 0px) scale(0);
  border-radius: 5px;
  color: #fff;
  border: none;
  opacity: 0;
  transition: transform ease 0.4s, opacity ease 0.4s;
}
.media-container:hover button {
  opacity: 1;
  transform: translate(4px, 0px) scale(1);
}

.table tbody tr th,
.table tbody tr td {
  vertical-align: middle;
  font-weight: 300;
}
.table tbody tr th.primary a,
.table tbody tr td.primary a {
  text-decoration: none;
  color: #0077ad;
  font-weight: 600;
}
.table tbody tr:first-child th,
.table tbody tr:first-child td {
  border-top: none;
}
.table thead tr th,
.table thead tr td {
  border-bottom: none;
}

.thumbnail-image {
  width: 150px;
}

.file {
  width: 5rem;
}
.cut-word {
  max-width: 190px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-brand {
  color: #008fc7;
}

.card-hover:hover {
  box-shadow: 2px 2px 7px 0px #dfdfdf;
}

.card-h {
  min-height: 170px;
}

.color-inherit {
  color: inherit;
}
.overflow {
  overflow: hidden;
}

.folder-title {
  padding-left: 0 !important;
  font-weight: 600 !important;
  color: #48465b !important;
  font-size: 1.1rem !important;
  margin: 6px 0 !important;
}

.kt-todo .kt-portlet__head {
  min-height: 55px !important;
}

.dropzone-container {
  height: 100px;
  border: 2px dashed #b3deee;
}
.m-h-30 {
  min-height: 30px;
}
[cdkDropList] {
  min-height: 50px; /* or some layout that ensures it's visible */
}

img.picture {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

/* .header-titles{

} */
.overflow {
  overflow: hidden;
}

.folder-title {
  padding-left: 0 !important;
  font-weight: 600 !important;
  color: #48465b !important;
  font-size: 1.1rem !important;
  margin: 6px 0 !important;
}

.kt-todo .kt-portlet__head {
  min-height: 55px !important;
}

.dropzone-container {
  height: 100px;
  border: 2px dashed #b3deee;
}
.m-h-30 {
  min-height: 30px;
}

img.picture {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

.dd-list {
  padding-left: 20px;
}
.dd,
.dd-item,
.dd-list,
.dd-placeholder {
  position: relative;
  margin: 0;
  display: block;
}
li.dd-item {
  list-style-type: none;
}
li.dd-item.expanded {
  list-style-type: none;
}

li.dd-item > a {
  color: #495057;
  display: block;
  padding: 0.5rem;
  background-color: transparent;

  transition: background-color ease 0.4s;
}
li.dd-item > a:hover {
  background-color: #f2f3f8;
  border-radius: 0.125rem;
  font-weight: 700;
  cursor: pointer;
}
.root-media:hover {
  cursor: pointer;
}
.dd-list {
  padding: 5px;
}
.item-icon {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  color: #008fc7;
}
.item-title {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
}
.counter {
  line-height: 1;
  display: inline-flex;
  align-items: center;
  background: #f2f3f8;
  min-width: 24px;
  justify-content: center;
  padding: 2px;
  border-radius: 5px;
}

.active-folder {
  background-color: #e1e1e1dc !important;
  border-radius: 0.125rem;
  font-weight: 700;
}

a.cut-word.color-inherit {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  /* max-width: none!important; */
  white-space: normal;
  /* display:flex */
  text-align: left;
}
.side-menu-mm {
  position: FIXED;
  max-height: 430px;
  overflow: hidden;
}
.right-menu-mm {
  position: RELATIVE;
  margin-left: 25% !important;
}
.right-menu-mm {
  overflow-y: auto;
  height: auto;
}
/* .header-titles{

} */
.kt-portlet__body.p-0.right-menu-mm {
  margin: 0 !important;
}
::ng-deep .media-modal .mat-dialog-container .right-menu-mm {
  margin-left: 0 !important;
}
.underlined {
  text-decoration: underline !important;
}
.breadcrumb-item:hover {
  color: #000000 !important;
  cursor: pointer !important;
}
.breadcrumb-item a:hover {
  color: #000000 !important;
  cursor: pointer !important;
}
.small-mat-checkbox {
  transform: scale(0.75) !important;
  color: #9d9b9b;
}
.border {
  border: 1px solid #08377d79 !important;
}
.modal-media {
  position: relative !important;
}
.filter-btn {
  color: #989898 !important;
  border: 1px solid #989898;
}
.filter-btn:hover {
  background-color: #807f7f !important;
  color: #fff !important;
}
.active-f {
  background-color: #807f7f !important;
  color: #fff !important;
}
.archive-anchor {
  color: #160e89;
  text-decoration: underline;
}

.archive-anchor:hover {
  color: #1809e1;
  cursor: pointer;
  text-decoration: underline !important;
}
.btn:disabled{
  cursor: crosshair;
}

.item-title{

  display: inline-block;
  max-width: 184px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
 } 

 .list {
  width: 300px;
  max-width: 100%;
  border: 1px solid #ccc;
  padding: 10px;
  background: #f9f9f9;
  min-height: 200px;
}

.item {
  padding: 8px;
  margin: 4px 0;
  border: 1px solid #ccc;
  background: white;
  cursor: move;
}
.example-custom-placeholder {
  background: #ccc;
  border: dotted 3px #999;
  min-height: 60px;
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
`, "",{"version":3,"sources":["webpack://./src/app/new-media/new-media-manager/media-folders/media-folders.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;;AAEA;EAEE,oBAAoB;EACpB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gCAAgC;EAChC,kCAAkC;EAClC,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uCAAuC;EACvC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,kDAAkD;AACpD;AACA;EACE,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;;;;;;;;;;;;;KAcK;AACL;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,uCAAuC;AACzC;AACA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;;KAEK;;AAEL;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uCAAuC;EACvC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kDAAkD;AACpD;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uCAAuC;EACvC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kDAAkD;AACpD;AACA;EACE,UAAU;EACV,uCAAuC;AACzC;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;;EAEE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB,EAAE,6CAA6C;AACjE;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;;GAEG;AACH;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;AACA;;;;EAIE,kBAAkB;EAClB,SAAS;EACT,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,6BAA6B;;EAE7B,sCAAsC;AACxC;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;;GAEG;AACH;EACE,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qCAAqC;AACvC;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,iCAAiC;EACjC,cAAc;AAChB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qCAAqC;AACvC;AACA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;CACxB;;CAEA;EACC,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,sDAAsD;AACxD","sourcesContent":[".folder-container {\r\n  text-align: center;\r\n  margin-left: 1rem;\r\n  margin-right: 1rem;\r\n  margin-bottom: 1.5rem;\r\n  width: 100px;\r\n  padding: 0;\r\n  align-self: start;\r\n  background: none;\r\n  border: none;\r\n  outline-color: transparent !important;\r\n  cursor: pointer;\r\n}\r\n.folder-icon {\r\n  font-size: 5em;\r\n  line-height: 1.25em;\r\n}\r\n.folder-icon-color {\r\n  color: #b3deee;\r\n  font-size: 7rem;\r\n  text-shadow: 1px 1px 0px #98c7d9;\r\n  /*color: #ffc107;*/\r\n}\r\n.folder-name {\r\n  overflow-wrap: break-word;\r\n  word-wrap: break-word;\r\n  hyphens: auto;\r\n}\r\n\r\n.flex-column .folder-container {\r\n  display: flex;\r\n  width: auto;\r\n  min-width: 100px;\r\n  text-align: left;\r\n  margin: 0;\r\n  margin-bottom: 1rem;\r\n}\r\n.flex-column .folder-icon,\r\n.flex-column .folder-name {\r\n  display: inline-flex;\r\n}\r\n.flex-column .folder-icon {\r\n  font-size: 1.4em;\r\n  margin-right: 1rem;\r\n}\r\n.file-icon-color {\r\n  color: #999;\r\n}\r\n\r\n.kt-avatar .kt-avatar__upload:hover {\r\n  -webkit-transition: all 0.3s;\r\n  transition: all 0.3s;\r\n  background-color: #f44336;\r\n  color: #fff;\r\n}\r\n\r\n.dorp-zone-media {\r\n  border: 2px dashed #008fc780;\r\n}\r\n\r\n.media-files .kt-portlet .kt-portlet__body {\r\n  padding-top: 0;\r\n}\r\n\r\n.kt-widget__files .kt-widget__media img.picture {\r\n  width: 100%;\r\n  height: 130px;\r\n  object-fit: cover;\r\n}\r\n\r\n.kt-widget__files .kt-widget__media img.file {\r\n  width: 7rem;\r\n  height: 130px;\r\n}\r\n.kt-widget__media > img {\r\n  height: 40vh;\r\n}\r\n\r\n.dragItem {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\nbutton.btn.not-allowed:hover {\r\n  cursor: not-allowed !important;\r\n}\r\n\r\n.theme-scroll {\r\n  height: 40vh !important;\r\n}\r\n\r\n.gallery .row > div {\r\n  width: 160px;\r\n}\r\n.gallery .row > div > .media-folder {\r\n  position: relative;\r\n  padding-top: 10px;\r\n}\r\n.gallery .row > div > .media-folder::before {\r\n  content: \"\";\r\n  width: 50%;\r\n  height: 10px;\r\n  border-radius: 10px 10px 0px 0px;\r\n  background-color: rgb(0, 119, 173);\r\n  position: absolute;\r\n  top: 0px;\r\n  left: 0px;\r\n}\r\n.gallery .row > div > .media-folder a {\r\n  width: 100%;\r\n  height: 100px;\r\n  background-color: #008fc7;\r\n  border-radius: 0px 10px 10px 10px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-bottom: 5px;\r\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 10px;\r\n}\r\n\r\n.gallery .row > div > .media-folder .delete-item-button {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  width: 32px;\r\n  height: 32px;\r\n  background-color: #fd397a;\r\n  transform: translate(4px, 0px) scale(0);\r\n  border-radius: 5px;\r\n  color: #fff;\r\n  border: none;\r\n  z-index: 1;\r\n  opacity: 0;\r\n  transition: transform ease 0.4s, opacity ease 0.4s;\r\n}\r\n.gallery .row > div > .media-folder:hover .delete-item-button {\r\n  opacity: 1;\r\n  transform: translate(4px, 0px) scale(1);\r\n}\r\n\r\n.gallery .row > div > .media-folder:hover .set-item-button {\r\n  opacity: 1;\r\n  transform: translate(5px, 0px) scale(1);\r\n}\r\n\r\n.gallery .row > div > .media-card {\r\n  position: relative;\r\n}\r\n\r\n.gallery .row > div > .media-card::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  height: 110px;\r\n  width: 100%;\r\n  background-color: #cfdbe0;\r\n  z-index: 0;\r\n  transform: rotate(5deg);\r\n  transform-origin: center;\r\n  border-radius: 5px;\r\n}\r\n\r\n.gallery .row > div > .media-card .img-view {\r\n  position: relative;\r\n  z-index: 1;\r\n  background-color: #fff;\r\n  border-radius: 6px;\r\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 10px;\r\n  height: 110px;\r\n  overflow: hidden;\r\n  border: solid 3px #fff;\r\n  margin-bottom: 5px;\r\n}\r\n.gallery .row > div > .media-card .doc-view {\r\n  position: relative;\r\n  z-index: 1;\r\n  background-color: #fff;\r\n  border-radius: 6px;\r\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 10px;\r\n  height: 110px;\r\n  overflow: hidden;\r\n  border: solid 3px #fff;\r\n  margin-bottom: 5px;\r\n  text-align: center;\r\n}\r\n\r\n.gallery .row > div > .media-card a > .img-src {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  object-position: center;\r\n}\r\n.media-card-dialog .img-src {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  object-position: center;\r\n}\r\n.gallery .row > div > .media-card a > .doc-src {\r\n  height: 100%;\r\n  object-fit: cover;\r\n  object-position: center;\r\n}\r\n\r\n/* .gallery .row > div > .media-card .delete-item-button {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    width: 32px;\r\n    height: 32px;\r\n    background-color: #fd397a;\r\n    transform: translate(4px, 0px) scale(0);\r\n    border-radius: 5px;\r\n    color: #fff;\r\n    border: none;\r\n    z-index: 1;\r\n    opacity: 0;\r\n    transition: transform ease 0.4s, opacity ease 0.4s;\r\n  } */\r\n.delete-item-button {\r\n  cursor: pointer;\r\n}\r\n.set-item-button {\r\n  cursor: pointer;\r\n}\r\n.item-name {\r\n  cursor: pointer;\r\n  color: rgb(0, 119, 173);\r\n}\r\n.gallery .row > div > .media-card:hover .delete-item-button {\r\n  opacity: 1;\r\n  transform: translate(4px, 0px) scale(1);\r\n}\r\n.folder-icon {\r\n  color: #fff;\r\n  padding: 14px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.table th,\r\n.table td {\r\n  border-top: 3px solid #ebedf2;\r\n}\r\n.customClass .tab-content {\r\n  background-color: red;\r\n}\r\n.img-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  overflow: hidden;\r\n}\r\n.pop-buttons {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-top: 5%;\r\n}\r\n/* .img-container  > img {\r\n\r\n  } */\r\n\r\n.modal-lg {\r\n  position: relative;\r\n  flex: 1 1 auto;\r\n  padding: 1rem;\r\n}\r\n.media-container {\r\n  position: relative;\r\n}\r\n.media-container .delete-item-button {\r\n  position: absolute;\r\n  top: 0;\r\n  z-index: 100;\r\n  right: 0;\r\n  width: 32px;\r\n  height: 32px;\r\n  background-color: #fd397a;\r\n  transform: translate(4px, 0px) scale(0);\r\n  border-radius: 5px;\r\n  color: #fff;\r\n  border: none;\r\n  opacity: 0;\r\n  transition: transform ease 0.4s, opacity ease 0.4s;\r\n}\r\n.media-container .set-item-button {\r\n  position: absolute;\r\n  top: 0;\r\n  z-index: 100;\r\n  left: 0;\r\n  width: 32px;\r\n  height: 32px;\r\n  background-color: #fd397a;\r\n  transform: translate(4px, 0px) scale(0);\r\n  border-radius: 5px;\r\n  color: #fff;\r\n  border: none;\r\n  opacity: 0;\r\n  transition: transform ease 0.4s, opacity ease 0.4s;\r\n}\r\n.media-container:hover button {\r\n  opacity: 1;\r\n  transform: translate(4px, 0px) scale(1);\r\n}\r\n\r\n.table tbody tr th,\r\n.table tbody tr td {\r\n  vertical-align: middle;\r\n  font-weight: 300;\r\n}\r\n.table tbody tr th.primary a,\r\n.table tbody tr td.primary a {\r\n  text-decoration: none;\r\n  color: #0077ad;\r\n  font-weight: 600;\r\n}\r\n.table tbody tr:first-child th,\r\n.table tbody tr:first-child td {\r\n  border-top: none;\r\n}\r\n.table thead tr th,\r\n.table thead tr td {\r\n  border-bottom: none;\r\n}\r\n\r\n.thumbnail-image {\r\n  width: 150px;\r\n}\r\n\r\n.file {\r\n  width: 5rem;\r\n}\r\n.cut-word {\r\n  max-width: 190px !important;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.text-brand {\r\n  color: #008fc7;\r\n}\r\n\r\n.card-hover:hover {\r\n  box-shadow: 2px 2px 7px 0px #dfdfdf;\r\n}\r\n\r\n.card-h {\r\n  min-height: 170px;\r\n}\r\n\r\n.color-inherit {\r\n  color: inherit;\r\n}\r\n.overflow {\r\n  overflow: hidden;\r\n}\r\n\r\n.folder-title {\r\n  padding-left: 0 !important;\r\n  font-weight: 600 !important;\r\n  color: #48465b !important;\r\n  font-size: 1.1rem !important;\r\n  margin: 6px 0 !important;\r\n}\r\n\r\n.kt-todo .kt-portlet__head {\r\n  min-height: 55px !important;\r\n}\r\n\r\n.dropzone-container {\r\n  height: 100px;\r\n  border: 2px dashed #b3deee;\r\n}\r\n.m-h-30 {\r\n  min-height: 30px;\r\n}\r\n[cdkDropList] {\r\n  min-height: 50px; /* or some layout that ensures it's visible */\r\n}\r\n\r\nimg.picture {\r\n  width: 100%;\r\n  height: 150px;\r\n  object-fit: cover;\r\n}\r\n\r\n/* .header-titles{\r\n\r\n} */\r\n.overflow {\r\n  overflow: hidden;\r\n}\r\n\r\n.folder-title {\r\n  padding-left: 0 !important;\r\n  font-weight: 600 !important;\r\n  color: #48465b !important;\r\n  font-size: 1.1rem !important;\r\n  margin: 6px 0 !important;\r\n}\r\n\r\n.kt-todo .kt-portlet__head {\r\n  min-height: 55px !important;\r\n}\r\n\r\n.dropzone-container {\r\n  height: 100px;\r\n  border: 2px dashed #b3deee;\r\n}\r\n.m-h-30 {\r\n  min-height: 30px;\r\n}\r\n\r\nimg.picture {\r\n  width: 100%;\r\n  height: 150px;\r\n  object-fit: cover;\r\n}\r\n\r\n.dd-list {\r\n  padding-left: 20px;\r\n}\r\n.dd,\r\n.dd-item,\r\n.dd-list,\r\n.dd-placeholder {\r\n  position: relative;\r\n  margin: 0;\r\n  display: block;\r\n}\r\nli.dd-item {\r\n  list-style-type: none;\r\n}\r\nli.dd-item.expanded {\r\n  list-style-type: none;\r\n}\r\n\r\nli.dd-item > a {\r\n  color: #495057;\r\n  display: block;\r\n  padding: 0.5rem;\r\n  background-color: transparent;\r\n\r\n  transition: background-color ease 0.4s;\r\n}\r\nli.dd-item > a:hover {\r\n  background-color: #f2f3f8;\r\n  border-radius: 0.125rem;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n}\r\n.root-media:hover {\r\n  cursor: pointer;\r\n}\r\n.dd-list {\r\n  padding: 5px;\r\n}\r\n.item-icon {\r\n  width: 30px;\r\n  height: 30px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: 18px;\r\n  color: #008fc7;\r\n}\r\n.item-title {\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n}\r\n.counter {\r\n  line-height: 1;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  background: #f2f3f8;\r\n  min-width: 24px;\r\n  justify-content: center;\r\n  padding: 2px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.active-folder {\r\n  background-color: #e1e1e1dc !important;\r\n  border-radius: 0.125rem;\r\n  font-weight: 700;\r\n}\r\n\r\na.cut-word.color-inherit {\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 3;\r\n  -webkit-box-orient: vertical;\r\n  /* max-width: none!important; */\r\n  white-space: normal;\r\n  /* display:flex */\r\n  text-align: left;\r\n}\r\n.side-menu-mm {\r\n  position: FIXED;\r\n  max-height: 430px;\r\n  overflow: hidden;\r\n}\r\n.right-menu-mm {\r\n  position: RELATIVE;\r\n  margin-left: 25% !important;\r\n}\r\n.right-menu-mm {\r\n  overflow-y: auto;\r\n  height: auto;\r\n}\r\n/* .header-titles{\r\n\r\n} */\r\n.kt-portlet__body.p-0.right-menu-mm {\r\n  margin: 0 !important;\r\n}\r\n::ng-deep .media-modal .mat-dialog-container .right-menu-mm {\r\n  margin-left: 0 !important;\r\n}\r\n.underlined {\r\n  text-decoration: underline !important;\r\n}\r\n.breadcrumb-item:hover {\r\n  color: #000000 !important;\r\n  cursor: pointer !important;\r\n}\r\n.breadcrumb-item a:hover {\r\n  color: #000000 !important;\r\n  cursor: pointer !important;\r\n}\r\n.small-mat-checkbox {\r\n  transform: scale(0.75) !important;\r\n  color: #9d9b9b;\r\n}\r\n.border {\r\n  border: 1px solid #08377d79 !important;\r\n}\r\n.modal-media {\r\n  position: relative !important;\r\n}\r\n.filter-btn {\r\n  color: #989898 !important;\r\n  border: 1px solid #989898;\r\n}\r\n.filter-btn:hover {\r\n  background-color: #807f7f !important;\r\n  color: #fff !important;\r\n}\r\n.active-f {\r\n  background-color: #807f7f !important;\r\n  color: #fff !important;\r\n}\r\n.archive-anchor {\r\n  color: #160e89;\r\n  text-decoration: underline;\r\n}\r\n\r\n.archive-anchor:hover {\r\n  color: #1809e1;\r\n  cursor: pointer;\r\n  text-decoration: underline !important;\r\n}\r\n.btn:disabled{\r\n  cursor: crosshair;\r\n}\r\n\r\n.item-title{\r\n\r\n  display: inline-block;\r\n  max-width: 184px;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n } \r\n\r\n .list {\r\n  width: 300px;\r\n  max-width: 100%;\r\n  border: 1px solid #ccc;\r\n  padding: 10px;\r\n  background: #f9f9f9;\r\n  min-height: 200px;\r\n}\r\n\r\n.item {\r\n  padding: 8px;\r\n  margin: 4px 0;\r\n  border: 1px solid #ccc;\r\n  background: white;\r\n  cursor: move;\r\n}\r\n.example-custom-placeholder {\r\n  background: #ccc;\r\n  border: dotted 3px #999;\r\n  min-height: 60px;\r\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
